import { useFormik } from "formik";
import { adminCreateShift } from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";
import moment from "moment";

const AddModalShift = ({ show, onCloseClick, getData }: any) => {
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      checkInTime: "",
      checkOutTime: "",
      tolerance: "",
      expiredDate: "",
      startOpen: "",
      category: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama harus diisi!"),
      checkInTime: Yup.string().required("Jam masuk harus diisi!"),
      checkOutTime: Yup.string().required("Jam pulang harus diisi!"),
      tolerance: Yup.string().required("Toleransi harus diisi!"),
      expiredDate: Yup.string().required("Tanggal kadaluwarsa harus diisi!"),
      startOpen: Yup.string().required("Jam mulai absen harus diisi!"),
      category: Yup.array().min(1, "Kategori karyawan harus diisi!"),
    }),
    onSubmit: (values) => {
      const formattedValues = {
        name: values.name,
        checkInTime: moment(values.checkInTime).format("HH:mm:ss"),
        checkOutTime: moment(values.checkOutTime).format("HH:mm:ss"),
        tolerance: values.tolerance,
        expiredDate: values.expiredDate,
        startOpen: moment(values.startOpen).format("HH:mm:ss"),
        category: values.category.map((cat: any) => cat.value),
      };

      adminCreateShift(formattedValues)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Shift <b>{response?.name}</b> berhasil ditambahkan!
            </div>
          );
          validation.resetForm();
        })
        .catch(() => {});
    },
  });

  const comboCategory = [
    { value: "EMPLOYEE", label: "EMPLOYEE" },
    { value: "SECURITY", label: "SECURITY" },
    { value: "CLEANING_SERVICE", label: "CLEANING SERVICE" },
    { value: "OFFICE_BOY", label: "OFFICE BOY" },
    { value: "DRIVER", label: "DRIVER" },
    { value: "GARDENER", label: "GARDENER" },
  ];

  useEffect(() => {
    if (!show) {
      validation.resetForm();
    }
  }, [show]);

  return (
    <Modal
      size="lg"
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
    >
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Tambah Shift
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="name" className="form-label">
              Nama Shift
            </Label>
            <Input
              type="text"
              className="form-control"
              id="name"
              name="name"
              placeholder="Nama shift"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.errors.name && validation.touched.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>
          <div className="mb-3">
            <Label htmlFor="categoty" className="form-label">
              Kategori Karyawan
            </Label>
            <Select
              value={validation.values.category || []}
              onChange={(e: any) => {
                validation.setFieldValue("category", e);
              }}
              options={comboCategory}
              closeMenuOnSelect={false}
              isMulti
              className={`basic-multi-select ${
                validation.errors.category && validation.touched.category
                  ? "is-invalid"
                  : ""
              }`}
              classNamePrefix="select"
              placeholder="Pilih Kategori Karyawan"
            />
            {validation.errors.category && validation.touched.category ? (
              <div className="invalid-feedback d-block">
                {validation.errors.category}
              </div>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="startOpen" className="form-label">
              Jam Mulai Absen
            </Label>
            <Flatpickr
              className="form-control"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
              }}
              onChange={(date: any) =>
                validation.setFieldValue("startOpen", date[0])
              }
              value={validation.values.startOpen || ""}
            />
            {validation.errors.startOpen && validation.touched.startOpen ? (
              <FormFeedback type="invalid" className="d-block">
                {validation.errors.startOpen}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="checkInTime" className="form-label">
              Jam Masuk
            </Label>
            <Flatpickr
              className="form-control"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
              }}
              onChange={(date: any) =>
                validation.setFieldValue("checkInTime", date[0])
              }
              value={validation.values.checkInTime || ""}
            />
            {validation.errors.checkInTime && validation.touched.checkInTime ? (
              <FormFeedback type="invalid" className="d-block">
                {validation.errors.checkInTime}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="checkOutTime" className="form-label">
              Jam Pulang
            </Label>
            <Flatpickr
              className="form-control"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
              }}
              onChange={(date: any) =>
                validation.setFieldValue("checkOutTime", date[0])
              }
              value={validation.values.checkOutTime || ""}
            />
            {validation.errors.checkOutTime &&
            validation.touched.checkOutTime ? (
              <FormFeedback type="invalid" className="d-block">
                {validation.errors.checkOutTime}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label for="tolerance" className="form-label">
              Toleransi (menit)
            </Label>
            <Input
              type="number"
              className="form-control"
              id="tolerance"
              name="tolerance"
              placeholder="Toleransi"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.tolerance || ""}
              invalid={
                validation.touched.tolerance && validation.errors.tolerance
                  ? true
                  : false
              }
            />
            {validation.errors.tolerance && validation.touched.tolerance ? (
              <FormFeedback type="invalid">
                {validation.errors.tolerance}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="expiredDate" className="form-label">
              Tanggal Kadaluwarsa
            </Label>
            <Flatpickr
              name="expiredDate"
              id="date-field"
              className="form-control"
              placeholder="Pilih Tanggal Kadaluwarsa"
              options={{
                locale: Indonesian,
                altInput: true,
                altFormat: "d F Y",
                dateFormat: "Y-m-d",
              }}
              onChange={(date: any) =>
                validation.setFieldValue(
                  "expiredDate",
                  moment(date[0]).format("YYYY-MM-DD")
                )
              }
              value={validation.values.expiredDate || ""}
            />
            {validation.errors.expiredDate && validation.touched.expiredDate ? (
              <FormFeedback type="invalid" className="d-block">
                {validation.errors.expiredDate}
              </FormFeedback>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Tambah
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

AddModalShift.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
};

export default AddModalShift;
